"use client"

// types.ts
type LocationData = {
  clientIp: string;
}

// context/IpContext.tsx
import React, {
  createContext, useContext, useEffect, useState
} from "react";

interface IpContextType {
  currentIp: string | null;
  setCurrentIp: (ip: string) => void;
}

const IpContext = createContext<IpContextType | undefined>(undefined);

export function IpProvider({
  children 
}: { children: React.ReactNode }) {
  const [currentIp, setCurrentIp] = useState<string | null>(null);

  useEffect(() => {
    const fetchIp = async () => {
      // Try to get IP from sessionStorage first
      const storedIp = sessionStorage.getItem("userIp");

      if (storedIp) {
        setCurrentIp(storedIp);

        return;
      }

      try {
        const response = await fetch("https://floral-boat-1b30.493878942.workers.dev/");
        const data: LocationData = await response.json();

        setCurrentIp(data.clientIp);
        sessionStorage.setItem("userIp", data.clientIp);
      } catch (error) {
        console.error("Failed to fetch IP:", error);
      }
    };

    fetchIp();
  }, []);

  const updateIp = (ip: string) => {
    setCurrentIp(ip);
    sessionStorage.setItem("userIp", ip);
  };

  return (
    <IpContext.Provider value={{
      currentIp, setCurrentIp: updateIp 
    }}>
      {children}
    </IpContext.Provider>
  );
}

export function useIp() {
  const context = useContext(IpContext);

  if (context === undefined) {
    throw new Error("useIp must be used within an IpProvider");
  }

  return context;
}

